import "./header.scss";
import {Container, Nav, Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import { useEffect, useState } from "react";
import {useLocation} from "react-router-dom";

function Header() {
    const [isTransparent, setIsTransparent] = useState(true);
    const [isHidden, setIsHidden] = useState(false);
    const [lastScrollTop, setLastScrollTop] = useState(0);

    const location = useLocation();

    const solidPaths = ['developer/list', 'property/list', 'event', 'property/add', 'not-found']

    useEffect(() => {

        solidPaths.map(path => {
            if(location.pathname.includes(path)) {
                setIsTransparent(false);
            }
        })

        const handleScroll = () => {
            let scrollTop = window.scrollY;
        
            // Check if user is still watching the video
            if (scrollTop < window.innerHeight * 0.5) {
              setIsTransparent(true);
              setIsHidden(false);
            } 
            // Hide navbar when scrolling down
            else if (scrollTop > lastScrollTop) {
              setIsHidden(true);
            } 
            // Show solid navbar when scrolling up
            else {
              setIsHidden(false);
              setIsTransparent(false);
            }
        
            setLastScrollTop(scrollTop);
          };
        
          window.addEventListener("scroll", handleScroll);
          return () => window.removeEventListener("scroll", handleScroll);
    });

    return(
        <header>
            <Navbar fixed={"top"}  expand={"lg"} className={`navbar navbar-default ${isTransparent ? "transparent" : "solid"} ${isHidden ? "hidden" : ""}`}>
                <Container fluid className={"nav-container"}>
                    <Navbar.Brand className={"navbar-brand"} href="/">
                        <img style={{
                            height: "2em",
                            width: "auto",
                            maxWidth: "100%",
                        }} src={"/luxora_dubai_logo.png"} alt={"Luxora Dubai"}/>
                    </Navbar.Brand>
                    {/*<Navbar.Toggle className={"navbar-toggle"} type="button" data-bs-toggle="collapse"*/}
                    {/*               data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false"*/}
                    {/*               aria-label="Toggle navigation">*/}
                    {/*    <span className="icon-bar"></span>*/}
                    {/*    <span className="icon-bar"></span>*/}
                    {/*    <span className="icon-bar"></span>*/}
                    {/*</Navbar.Toggle>*/}
                    <Navbar.Toggle className={"navbar-toggle"} aria-controls={"navbarNav"}>
                        <i className={"bi bi-list navbar-hamburger"}></i>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="navbarNav">
                        <Nav className={"ms-auto nav-items"}>
                            <Nav.Link className={"nav-item"} href="/developer/list"><span className={"item-name"}>DEVELOPERS</span></Nav.Link>
                            <Nav.Link  className={"nav-item"} href="/property/list"><span className={"item-name"}>PROPERTIES</span></Nav.Link>
                            {/*<Nav.Link className={"nav-item"} href="/contact">Contact</Nav.Link>*/}
                            <Nav.Link className={"nav-item"} href="/blog/list?page_num=1"><span className={"item-name"}>BLOG</span></Nav.Link>
                            <Nav.Link className={"nav-item"} href="/event/list"><span className={"item-name"}>EVENTS</span></Nav.Link>
                            {/* <Nav.Link className={"nav-item"}><FontAwesomeIcon icon={faUser as IconProp} /></Nav.Link> */}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}

export default Header;